<nav
  class="header-container"
  [ariaLabel]="'mainNavigation' | translate"
>
  <div class="application-headers">
    <img
      src="../../../assets/images/softdocs-logo.png"
      class="softdocs-logo"
      [alt]="'softdocsLogo' | translate"
    />
    <div class="logo-divider"></div>
    <h1 class="header-title">{{ title | translate }}</h1>
  </div>

  <div class="nav-buttons">
    @if (isWebApps && isValidUser) {
      @if (hasWebCapture || hasTranscriptProcessing) {
        <div class="app-switcher-anchor">
          <p-button
            class="dap-app-switcher header-button"
            id="app-switcher-button"
            tooltipPosition="bottom"
            variant="text"
            severity="contrast"
            icon="fa-solid fa-grid-round"
            [ariaLabel]="'appSwitcher' | translate"
            [pTooltip]="'appSwitcher' | translate"
            [attr.aria-haspopup]="'true'"
            [attr.aria-expanded]="openMenu() === 'appSwitcher' ? 'true' : 'false'"
            [ngClass]="{ active: openMenu() === 'appSwitcher' }"
            (click)="toggleMenu('appSwitcher')"
          >
          </p-button>
          @if (openMenu() === 'appSwitcher') {
            <div
              class="app-switcher-menu"
              tabindex="-1"
              aria-labelledby="app-switcher-button"
              (focusout)="onMenuFocusOut($event)"
              (keydown)="onMenuKeydown($event)"
            >
              <ul class="app-switcher-list">
                @if (hasWebCapture) {
                  <li>
                    <a
                      routerLink="/webcapture"
                      class="dap-app-web-capture app-switcher-option web-capture"
                      [attr.aria-label]="'webCapture' | translate"
                      (click)="openMenu.set(null)"
                    >
                      <img
                        src="../../../assets/images/softdocs-logo.png"
                        class="app-logo"
                        alt=""
                      />
                      <span class="app-divider"></span>
                      <span class="app-name">{{ 'webCapture' | translate }}</span>
                    </a>
                  </li>
                }
                @if (hasTranscriptProcessing) {
                  <li>
                    <a
                      routerLink="/transcripts"
                      class="dap-app-transcript-processing app-switcher-option transcript-processing"
                      [attr.aria-label]="'transcriptProcessing' | translate"
                      (click)="openMenu.set(null)"
                    >
                      <img
                        src="../../../assets/images/softdocs-logo.png"
                        class="app-logo"
                        alt=""
                      />
                      <span class="app-divider"></span>
                      <span class="app-name">{{ 'transcriptProcessing' | translate }}</span>
                    </a>
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      }
      <p-button
        class="dap-resource-center header-button"
        aria-haspopup="menu"
        tooltipPosition="bottom"
        variant="text"
        severity="contrast"
        icon="fa-solid fa-circle-question"
        [ariaLabel]="'resourceCenter' | translate"
        [pTooltip]="'resourceCenter' | translate"
      >
      </p-button>
    }
    @if (isWebApps || isOutlook) {
      <p-button
        class="dap-settings-menu header-button"
        id="settings-button"
        tooltipPosition="bottom"
        variant="text"
        severity="contrast"
        icon="fa-solid fa-gear"
        [ariaLabel]="'settingsMenu' | translate"
        [pTooltip]="'settings' | translate"
        [attr.aria-haspopup]="'true'"
        [attr.aria-expanded]="openMenu() === 'settings' ? 'true' : 'false'"
        [ngClass]="{ active: openMenu() === 'settings' }"
        (click)="toggleMenu('settings')"
      >
      </p-button>
    }
    @if (openMenu() === 'settings') {
      <div
        class="settings-menu"
        tabindex="-1"
        aria-labelledby="settings-button"
        (focusout)="onMenuFocusOut($event)"
        (keydown)="onMenuKeydown($event)"
      >
        <ul class="settings-list">
          @if (isAccessITPAdmin) {
            <li class="settings-list-items">
              <a
                routerLink="/intelligence/itpmanagement"
                class="dap-intelligence-settings settings-option"
                tabindex="0"
                [attr.aria-label]="'intelligenceSettings' | translate"
                (click)="openMenu.set(null)"
              >
                <span>
                  <i
                    class="fa-solid fa-microchip-ai"
                    aria-hidden="true"
                  ></i>
                  {{ 'intelligenceSettings' | translate }}
                </span>
              </a>
            </li>
          }
          @if (hasWebCapture || isVirtualPrinterOnly) {
            <li class="settings-list-items">
              <a
                href="#"
                class="dap-content-url settings-option"
                tabindex="0"
                [attr.aria-label]="'contentUrl' | translate"
                (click)="changeContentUrl(); $event.preventDefault()"
              >
                <span>
                  <i
                    class="fa-solid fa-browser"
                    aria-hidden="true"
                  ></i>
                  {{ 'contentUrl' | translate }}
                </span>
              </a>
            </li>
          }
          <li class="settings-list-items">
            <a
              href="#"
              class="dap-about settings-option"
              tabindex="0"
              [attr.aria-label]="'about' | translate"
              (click)="showAboutModal = true; openMenu.set(null); $event.preventDefault()"
            >
              <span>
                <i
                  class="fa-solid fa-circle-info"
                  aria-hidden="true"
                ></i>
                {{ 'about' | translate }}
              </span>
            </a>
          </li>
          <li
            class="separator-line"
            role="presentation"
            aria-hidden="true"
          >
            <hr />
          </li>
          <li
            class="user-name settings-list-items"
            role="presentation"
            aria-hidden="true"
          >
            {{ user?.customClaims?.display_name || 'User' }}
          </li>
          <li
            class="separator-line"
            role="presentation"
            aria-hidden="true"
          >
            <hr />
          </li>
          <li class="settings-list-items">
            <a
              href="#"
              class="dap-sign-out settings-option"
              tabindex="0"
              [attr.aria-label]="'signOut' | translate"
              (click)="signOut(); $event.preventDefault()"
            >
              <span>
                <i
                  class="fa-solid fa-right-from-bracket"
                  aria-hidden="true"
                ></i>
                {{ 'signOut' | translate }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    }
  </div>
</nav>

<p-dialog
  class="about-dialog"
  [header]="'about' | translate"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeAriaLabel]="'close' | translate"
  [(visible)]="showAboutModal"
>
  <p>{{ 'aboutHeader' | translate }}</p>
  <span class="title"> {{ 'conformanceStatus' | translate }} </span>
  <p>
    <a
      class="dap-wcag-link"
      href="https://www.w3.org/WAI/standards-guidelines/wcag/"
      target="_blank"
      >{{ 'wcagLink' | translate }}</a
    >
    {{ 'conformanceStatusText' | translate }}
    <a
      class="dap-vpat-link"
      href="https://www.softdocs.com/trust/"
      target="_blank"
      >{{ 'vpatLink' | translate }}</a
    >
  </p>
  <hr class="separator-line" />
  <span class="title"> {{ 'feedback' | translate }} </span>
  <p>{{ 'feedbackText' | translate }}</p>
  <ul>
    <li>{{ 'feedbackPhone' | translate }}</li>
    <li>{{ 'feedbackEmail' | translate }}</li>
    <li>{{ 'feedbackPostal' | translate }}</li>
  </ul>
  <p>{{ 'feedbackEnd' | translate }}</p>
  <hr class="separator-line" />
  <div class="about-buttons">
    <p-button
      label="{{ 'close' | translate }}"
      class="dap-close-about-modal close-button"
      [attr.aria-label]="'close' | translate"
      (click)="showAboutModal = false"
    >
    </p-button>
  </div>
</p-dialog>
